import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { authHeader } from "@/utils/userAuth";
import { trackPurchase } from "@/utils/pixel";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PRICE_EUR = { "2": 2, "3": 10, "full": 197, "bundle": 50, "advanced": 147, "coaching": 490 };
const LESSON_KEY = { "2": "lesson_2", "3": "lesson_3", "full": "full_course", "bundle": "bundle_234", "advanced": "bundle_5_9", "coaching": "coaching_bundle" };

export default function CheckoutSuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const lesson = params.get("lesson") || "2";
  const [status, setStatus] = useState("checking");
  const [error, setError] = useState("");
  const [firedPurchase, setFiredPurchase] = useState(false);

  useEffect(() => {
    if (!sessionId) { setError("session_id mancante"); setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await axios.get(`${API}/checkout/status/${sessionId}`, { headers: authHeader() });
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (!firedPurchase) {
            try {
              const me = await axios.get(`${API}/users/me`, { headers: authHeader() });
              const lk = LESSON_KEY[lesson] || `lesson_${lesson}`;
              const eventId = `purchase_${me.data.id}_${lk}`;
              trackPurchase(eventId, PRICE_EUR[lesson] ?? 0, "EUR", lk);
              setFiredPurchase(true);
            } catch { /* ignore */ }
          }
          setTimeout(() => {
            const target = lesson === "full" ? "/corso/area-membri?just_unlocked=1" : `/corso/lezione/${lesson}?just_unlocked=1`;
            navigate(target);
          }, 1200);
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 8) setTimeout(poll, 1500);
        else setStatus("timeout");
      } catch (e) {
        setError(e?.response?.data?.detail || "Errore verifica pagamento");
        setStatus("error");
      }
    };
    poll();
  }, [sessionId, lesson, navigate, firedPurchase]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--np-tertiary)" }}>
      <div className="max-w-md w-full bg-white rounded-2xl shadow-[0_30px_80px_-30px_rgba(26,42,58,0.35)] overflow-hidden">
        <div className="h-2 bg-tension" />
        <div className="p-8 text-center">
          {status === "checking" && (
            <>
              <Loader2 className="animate-spin mx-auto mb-4" size={32} style={{ color: "var(--np-secondary)" }} />
              <h1 className="text-2xl" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>Verifica pagamento in corso…</h1>
            </>
          )}
          {status === "paid" && (
            <>
              <CheckCircle2 className="text-emerald-600 mx-auto mb-4" size={40} />
              <h1 className="text-2xl" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>Pagamento ricevuto</h1>
              <p className="mt-2 text-sm" style={{ color: "var(--np-muted)" }}>Ti porto alla Lezione {lesson}…</p>
            </>
          )}
          {(status === "error" || status === "expired" || status === "timeout") && (
            <>
              <h1 className="text-2xl" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>
                {status === "expired" ? "Sessione scaduta" : "Stato pagamento incerto"}
              </h1>
              <p className="mt-2 text-sm" style={{ color: "var(--np-muted)" }}>{error || "Riprova fra qualche istante o controlla la mail."}</p>
              <Link to="/corso/lezione/1" className="cta-btn mt-6 inline-flex">Torna alle lezioni</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
